import React, { type ComponentType, type ReactElement } from 'react';
import { Consumer as StyleMarshal } from '../common/context';
import type { ClassName } from '../types';

export type StyleMarshalContext = {
	insertStyle: (className: ClassName, style: string) => void;
	removeStyle: (className: ClassName) => void;
};

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default <TProps,>(
		Component: ComponentType<TProps>,
		// @ts-expect-error - TS2344 - Type 'TProps' does not satisfy the constraint 'StyleMarshalContext'.
	): ((props: Flow.Diff<TProps, StyleMarshalContext>) => ReactElement) =>
	// @ts-expect-error - TS2344 - Type 'TProps' does not satisfy the constraint 'StyleMarshalContext'.
	(props: Flow.Diff<TProps, StyleMarshalContext>) => (
		<StyleMarshal>
			{({ insert, remove }) => (
				// @ts-expect-error - TS2322 - Type '{ insertStyle: (className: string, rule: string) => void; removeStyle: (className: string) => void; } & Diff<TProps, StyleMarshalContext> & { ...; }' is not assignable to type 'IntrinsicAttributes & TProps & { children?: ReactNode; }'.
				<Component insertStyle={insert} removeStyle={remove} {...props}>
					{/* @ts-expect-error - TS2339 - Property 'children' does not exist on type 'Diff<TProps, StyleMarshalContext>'. */}
					{props.children}
				</Component>
			)}
		</StyleMarshal>
	);
